"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressOnlyToJSON = exports.AddressOnlyFromJSONTyped = exports.AddressOnlyFromJSON = void 0;
var runtime_1 = require("../runtime");
function AddressOnlyFromJSON(json) {
    return AddressOnlyFromJSONTyped(json, false);
}
exports.AddressOnlyFromJSON = AddressOnlyFromJSON;
function AddressOnlyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'additional': !(0, runtime_1.exists)(json, 'additional') ? undefined : json['additional'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'countryCode': json['countryCode'],
    };
}
exports.AddressOnlyFromJSONTyped = AddressOnlyFromJSONTyped;
function AddressOnlyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'additional': value.additional,
        'street': value.street,
        'houseNumber': value.houseNumber,
        'zipCode': value.zipCode,
        'city': value.city,
        'countryCode': value.countryCode,
    };
}
exports.AddressOnlyToJSON = AddressOnlyToJSON;
//# sourceMappingURL=AddressOnly.js.map